import Modernizr from 'modernizr';
global.Modernizr = Modernizr;
